import { KeyRoundIcon, MailIcon, UserIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'

import { AuthMethods } from '../../components/AuthMethods'
import {
  PreferenceButton,
  PreferenceCategory,
  PreferenceDiv,
  PreferenceInfo,
  PreferenceInput,
  PreferenceLink,
  PreferenceScreen,
  PreferenceSubmit,
} from '../../components/Preference'
import { authClient, useMe } from '../../lib/auth-client'

export default function AccountSettings() {
  const { data: me, mutate: mutateMe } = useMe()
  const [displayName, setDisplayName] = useState('')
  const [busy, setBusy] = useState(false)
  const [claimOpen, setClaimOpen] = useState(false)

  useEffect(() => {
    if (me?.user?.name != null) setDisplayName(me.user.name)
  }, [me?.user?.name])

  async function saveName() {
    setBusy(true)
    try {
      const { error: err } = await authClient.updateUser({
        name: displayName.trim(),
      })
      if (err) {
        toast.error(err.message || 'Naam bewaren mislukt')
        return
      }
      toast.success('Naam bewaard')
      await mutateMe()
    } finally {
      setBusy(false)
    }
  }

  return (
    <PreferenceScreen title="Account" backHref="/settings">
      {me?.user?.isAnonymous ? (
        <PreferenceCategory filled>
          <PreferenceInfo
            icon={<UserIcon className="h-6 w-6" />}
            title="Gastmodus"
            summary="Bewaar je account met e-mail of Google zodat je later terug kunt."
          />
          {!claimOpen ? (
            <PreferenceButton
              title="Bewaar met e-mail of Google"
              onPress={() => setClaimOpen(true)}
            />
          ) : (
            <PreferenceDiv className="px-5 py-4 !bg-green-50 text-green-950 first:rounded-t-2xl last:rounded-b-2xl rounded">
              <AuthMethods
                callbackURL="/settings/account"
                onDone={() => void mutateMe()}
              />
            </PreferenceDiv>
          )}
        </PreferenceCategory>
      ) : (
        <>
          <PreferenceCategory filled>
            <PreferenceInput
              icon={<UserIcon className="h-6 w-6" />}
              title="Naam"
              value={displayName}
              onChange={setDisplayName}
              placeholder="Jouw naam"
              autoComplete="name"
            />
            <PreferenceSubmit
              title="Bewaren"
              onPress={saveName}
              disabled={busy || !displayName.trim()}
            />
          </PreferenceCategory>

          <PreferenceCategory title="Beveiliging" filled>
            <PreferenceLink
              icon={<MailIcon className="h-6 w-6" />}
              title="E-mailadres"
              summary={me?.user?.email || '—'}
              href="/settings/account/email"
            />
            <PreferenceLink
              icon={<KeyRoundIcon className="h-6 w-6" />}
              title="Wachtwoord"
              summary={
                me?.hasPassword
                  ? 'Wachtwoord wijzigen'
                  : 'Nog geen wachtwoord ingesteld'
              }
              href="/settings/account/password"
            />
          </PreferenceCategory>
        </>
      )}
    </PreferenceScreen>
  )
}
